import { BrandId, CardType } from '../enums/enums';
import { globals } from '../globals';
import { handleDLMiniCartClick } from 'common-ui';

/**
 * Returns the image URL for a gift card or initial deposit card based on brand and card type.
 *
 * @param {string} brandId - The ID of the brand.
 * @param {string} cardType - The type of the card (e.g., gift card or deposit).
 * @returns {string} The constructed image URL.
 */
export const getGiftAndDepositeCardImage = (brandId: string, cardType: string): string => {
  const normalizedBrandId = [BrandId.LAW, BrandId.WPE, BrandId.LWNZ].includes(brandId as BrandId)
    ? BrandId.LW
    : brandId;
  const imageName = cardType === CardType.DEPOSIT ? 'initialdeposit' : 'giftcard';

  return `${globals.publicHost}/images/${globals.country}/en/product/${normalizedBrandId}-${imageName}.png`;
};

/**
 * Handles a click event on a link element and prevents default navigation
 * if the user is already on the target page. Also calls an optional close handler.
 *
 * @param {React.MouseEvent<HTMLAnchorElement>} e - The click event.
 * @param {string} href - The target URL for navigation.
 * @param {Function} [onClose=() => {}] - Optional callback invoked after the check.
 */
export const handleRedirectionClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string, onClose = () => {}) => {
  const currentUrl = window.location.pathname;
  if (currentUrl === href) {
    e.preventDefault();
  }
  onClose();
};

/**
 * Sends a mini cart click event to the data layer if the event string is not empty.
 *
 * @param {string} clickEvent - The name or identifier of the click event.
 */
export const handleMiniCartClickEvents = (clickEvent: string) => {
  clickEvent !== '' && handleDLMiniCartClick('miniCartClick', clickEvent);
};
